import React from "react";

const SvgSagittarius = (props) => {
  return (
    <svg
      viewBox="0 0 36.36 36.36"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M34.86 0H22.97c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h8.27L18.7 15.54l-4.18-4.18c-.59-.59-1.53-.59-2.12 0s-.59 1.53 0 2.12l4.18 4.18L.44 33.8a1.49 1.49 0 000 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44L18.7 19.78l4.18 4.18c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12l-4.18-4.18L33.36 5.12v8.27c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V1.5c0-.83-.67-1.5-1.5-1.5z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgSagittarius;
